import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { Auth, Authenticate } from "./screens/Auth";
import { useAuth } from "./AuthContext";
import Tabview from "./components/Tabview";

import PrivacyPolicy from "./components/privacy-policy";
import TermsOfService from "./components/terms-of-service";

import style from "./App.module.css";

function App() {
    const { user } = useAuth();

    document.addEventListener("focusin", (event: any) => {
        if (
            event.target.tagName === "INPUT" ||
            event.target.tagName === "TEXTAREA"
        ) {
            event.preventDefault();
            event.target.scrollIntoView(false);
        }
    });

    return (
        <Router>
            <Routes>
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-service" element={<TermsOfService />} />
                <Route
                    path="/delete"
                    element={<div>계정 삭제는 계정 탭에서 가능합니다!</div>}
                />
                <Route path="/auth/success" element={<Authenticate />} />
                <Route
                    path="*"
                    element={
                        <div className={style["container"]}>
                            <div className={style["wrapper--notice"]}>
                                <div></div>
                            </div>
                            <div className={style["wrapper--app"]}>
                                {!user ? <Auth /> : <Tabview></Tabview>}
                            </div>
                        </div>
                    }
                />
            </Routes>
        </Router>
    );
}

export default App;
